module.exports = __webpack_public_path__ + "media/site/images/case_studies/sensor_cloud/alarms1@2x-0d7fdfdbe8741e8f55435b1b42f9c0ea.png";